import React from 'react';
import VisibilitySensor from 'react-visibility-sensor';

import {
  Slider,
  TopImageWrapper,
  TopImage,
  Handle,
} from './ComparisonSlider.styled';

const TIMING = 750;
const END = 650;
const MOBILE_END = 200;

class ComparisonSlider extends React.Component {
  constructor() {
    super();

    this.state = {
      dragging: false,
      dragPosition: 0,
      animating: false,
      hasAnimated: false,
    };

    this.mouseDown = this.mouseDown.bind(this);
    this.mouseMove = this.mouseMove.bind(this);
    this.mouseUp = this.mouseUp.bind(this);
    this.mouseLeave = this.mouseLeave.bind(this);
    this.animate = this.animate.bind(this);
    this.handleChange = this.handleChange.bind(this);
  }

  mouseDown() {
    this.setState({
      dragging: true,
    });
  }

  mouseMove(e) {
    e.preventDefault();
    e.stopPropagation();

    if (!this.state.dragging) return;

    let pageX = e.touches ? e.touches[0].pageX : e.pageX;
    this.positionOverlay(pageX);
  }

  mouseUp() {
    this.setState({
      dragging: false,
    });
  }

  mouseLeave() {
    this.setState({
      dragging: false,
    });
  }

  positionOverlay(pageX) {
    this.setState({
      dragPosition: pageX,
      animating: false,
    });
  }

  animateOverlay(pageX) {
    if (this.state.animating) {
      this.setState({
        dragPosition: pageX,
      });
    }
  }

  animate() {
    if (typeof window !== 'undefined') {
      if (!this.state.hasAnimated) {
        const end = window.innerWidth > 900 ? END : MOBILE_END;
        this.setState({ animating: true, hasAnimated: true }, () => {
          this.animateOverlay(end + 100);
          setTimeout(() => {
            this.animateOverlay(end - 75);
            setTimeout(() => {
              this.animateOverlay(end);
              setTimeout(() => {
                this.setState({ animating: false });
              }, TIMING);
            }, TIMING);
          }, TIMING);
        });
      }
    }
  }

  handleChange(isVisible) {
    if (isVisible) {
      this.animate();
    }
  }

  render() {
    return (
      <VisibilitySensor
        onChange={this.handleChange}
        partialVisibility={true}
        minTopValue={300}
      >
        <Slider
          onMouseMove={this.mouseMove}
          onMouseLeave={this.mouseLeave}
          onMouseUp={this.mouseUp}
        >
          <TopImageWrapper
            style={{ width: this.state.dragPosition + 'px' }}
            animating={this.state.animating}
          >
            <TopImage />
          </TopImageWrapper>
          <Handle
            style={{ left: this.state.dragPosition + 'px' }}
            animating={this.state.animating}
            dragging={this.state.dragging}
            onMouseDown={this.mouseDown}
            onTouchStart={this.mouseDown}
            onMouseMove={this.mouseMove}
            onTouchMove={this.mouseMove}
            onMouseUp={this.mouseUp}
            onTouchEnd={this.mouseUp}
          />
        </Slider>
      </VisibilitySensor>
    );
  }
}

export default ComparisonSlider;
